// src/components/home/HeroBadge.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { FaRocket, FaArrowRight } from "react-icons/fa";
import "./HeroBadge.css";

const HeroBadge = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bvh-hero-badge-container"
      onClick={() => navigate("/our-journey")}
      role="button"
      tabIndex={0}
    >
      <span className="bvh-hero-badge-tag">
        <FaRocket style={{ fontSize: "0.75rem" }} /> NEW
      </span>
      <span className="bvh-hero-badge-text">
        BodhAI V2 Beta is Live <span className="bvh-hero-badge-divider">•</span>{" "}
        <span className="bvh-highlight-text">Coming Soon: BodhAI v2.0</span>
      </span>
      <span className="bvh-hero-badge-btn">
        Learn More <FaArrowRight style={{ fontSize: "0.75rem" }} />
      </span>
    </div>
  );
};

export default React.memo(HeroBadge);
